import { render, staticRenderFns } from "./messagelist.vue?vue&type=template&id=c1604476&scoped=true"
import script from "./messagelist.vue?vue&type=script&lang=js"
export * from "./messagelist.vue?vue&type=script&lang=js"
import style0 from "./messagelist.vue?vue&type=style&index=0&id=c1604476&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1604476",
  null
  
)

export default component.exports